export const OrderEndpoints = {
  root: '/orders',
  printRoot: '/print/orders'
}
